import { useEffect, useState } from "react";
import authService from "../../services/auth.service";
import { TeamsToken } from "../../types/auth/TeamsToken";
import ChatManagement from "../Copilot/ChatManagement";
import { useTeamsAuth } from "../../hooks/useTeamsAuth";
import TeamsPageLayout from "./TeamsPageLayout";

interface ciqprops {
  token: string;
  inTeams: boolean;
}
const CiQPilot: React.FC<ciqprops> = ({ token, inTeams }) => {
  const [teamsUser, setTeamsUser] = useState<TeamsToken>({ token: token });
  const [voiceTokenReady, setVoiceTokenReady] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const teamsAuth = useTeamsAuth();
  localStorage.setItem("TeamsTempToken", token);
  console.log(token);

  useEffect(() => {
    getVoiceAIToken();
  }, [])

  function getVoiceAIToken() {
    authService
      .authenticateVoiceAIFromTeams(teamsUser)
      .then((teamsAuthDetails) => {
        if (teamsAuthDetails != null) {
          teamsAuth?.setFirstName(teamsAuthDetails.firstName);
          teamsAuth?.setVoiceAIToken(teamsAuthDetails.token);
          teamsAuth?.setIsLoginEnabled(teamsAuthDetails.isLoginEnabled);
          localStorage.setItem("VoiceAIToken", teamsAuthDetails.token);
          setVoiceTokenReady(true);
        }
      })
      .catch(err => {
        console.error('Error while authenticating teams token: ', err);
        setError("Something went wrong. Please try again.");
      })
  }

  if (error) {
    return (
        <div className="h-100 text-center mt-5">
          <h3>⚠️ Something went wrong</h3>
          <p>{error}</p>
        </div>
    );
  }

  if (teamsAuth?.isLoginEnabled === false) {
    return (
      <TeamsPageLayout>
        <div className="text-center">
          <h3>User login is currently disabled</h3>
          <p>You're not authorized to access this feature.</p>
          <p>Please contact your Microsoft administrator.</p>
        </div>
      </TeamsPageLayout>
    );
  }

  if (teamsAuth?.isLoginEnabled === null || !voiceTokenReady) {
    return (
     <div className='h-100'>Loading assistant…</div>
    );
  }

  return (
    <div className="ms-teams-context h-100">
      <ChatManagement />
    </div>
  );
};

export default CiQPilot;